import axios from 'axios';
import { apiService } from './api';
import { UploadFileEntry, UploadRequest, UploadResponse } from '@/types/upload';

// Browsers often report '' for .sav, and the same value must be used for both the
// signing request and the PUT, so pin a fallback.
const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

export const getContentType = (file: File): string => file.type || DEFAULT_CONTENT_TYPE;

export const requestUploadUrls = (request: UploadRequest): Promise<UploadResponse> =>
  apiService.post<UploadResponse>('/v1/wave-upload', request);

export const putFileToS3 = (
  entry: UploadFileEntry,
  file: File,
  onProgress: (percent: number) => void
): Promise<void> =>
  axios
    .put(entry.uploadUrl, file, {
      headers: { 'Content-Type': entry.contentType },
      onUploadProgress: (event) => {
        if (event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total));
        }
      },
    })
    .then(() => undefined);

export const getUploadErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return 'Upload failed. Please try again.';
};
